/* eslint-disable @typescript-eslint/no-require-imports */
import React, { useState, useEffect, useLayoutEffect } from "react";
import "./style.css";
import * as Utils from "../Utils";
import { getFromIndexedDB } from "./../services/indexedDb";
import longhorizontal from "../assets/longhorizontal.svg";
import longvertical from "../assets/longvertical.svg";
import q1Image from "../assets/quad1.png";
import q2Image from "../assets/quad2.png";
import q3Image from "../assets/quad3.png";
import q4Image from "../assets/quad4.png";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

let allLayers = [];

export const Printout = () => {
  const [isLoading, setLoading] = useState(true);
  const [imgArray, setImgArray] = useState([]);
  const [overheadImgArray, setOverheadImgArray]= useState([]);
  const [levels, setLevels] = useState(0);
  const [savedAllLayers,setSavedAllLayers] = useState([]);
  const queryString = window.location.hash.split("?")[1];
  const urlParams = new URLSearchParams(queryString);
  const data = decodeURIComponent(urlParams.get("data"));
  const container = data.split(":");
  const storagetype = container[0];
  const containerID = Number(container[1]);
  const quadid = Number(container[2]);

  const handleClearStates = (e) => {
    e.preventDefault(); 

    if(allLayers.length>0){
      console.log("back")
      allLayers.length = 0
      window.location.href = "#/finalPackingPage"
    }
    //allLayers.length = 0;
  }

  function switchImages(){
    console.log("switchImages: " + quadid);
    switch(quadid){
      case 1:
        return(
        <img
          className="overlap-group-2"
          src={q1Image}
        ></img>
        )
      case 2:
        return(
          <img
            className="overlap-group-2"
            src={q2Image}
          ></img>
          )
      case 3:
        return(
          <img
            className="overlap-group-2"
            src={q3Image}
          ></img>
          )
      case 4:
        return(
          <img
            className="overlap-group-2"
            src={q4Image}
          ></img>
        )
    }
  }

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    [`&.${tableRowClasses.root}`]: {
      height: "200px",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      height: 5,
    },
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
      padding: 2,
    },
  }));

  /*async function addImages(){
    const storedImageArray = localStorage.getItem('imagesArray');
    if (storedImageArray) {
      // Check if the stored data is a valid JSON string
      try {
        const parsedArray = JSON.parse(storedImageArray);

        if (Array.isArray(parsedArray)) {
          setImgArray(parsedArray);
        } else {
          console.error("Stored data is not an array");
        }
      } catch (e) {
        console.error("Failed to parse stored data:", e);
      }
    }
    const overheadImageArray = localStorage.getItem('overheadImagesArray');
    if (overheadImageArray) {
      // Check if the stored data is a valid JSON string
      try {
        const parsedArray = JSON.parse(overheadImageArray);

        if (Array.isArray(parsedArray)) {
          setOverheadImgArray(parsedArray);
        } else {
          console.error("Stored data is not an array");
        }
      } catch (e) {
        console.error("Failed to parse stored data:", e);
      }
    } 
  }*/

  async function addImages() {
    try {
      const imagesArray = await getFromIndexedDB("imagesArray");

      if (Array.isArray(imagesArray)) {
        setImgArray(imagesArray);
      } else if (imagesArray != null) {
        console.error("IndexedDB imagesArray is not an array");
      }

      const overheadImagesArray = await getFromIndexedDB("overheadImagesArray");

      if (Array.isArray(overheadImagesArray)) {
        setOverheadImgArray(overheadImagesArray);
      } else if (overheadImagesArray != null) {
        console.error("IndexedDB overheadImagesArray is not an array");
      }
    } catch (err) {
      console.error("Failed to load images from IndexedDB:", err);
    }
  }

  async function waitForSetContainers() {
    const storeObject = await getLevels(storagetype, containerID, quadid).then(
      (max) => {
        console.log("hit get getLevels");
        setLevels(max);
        if (allLayers.length<max) {
          for (let x = 1; x <= max; x++) {
            getLayer(max, storagetype, containerID, quadid, x);
          }
          setSavedAllLayers([...allLayers]);

        }      
      }
    );
    //setContainerCounter(storeObject);
    if (storeObject) {
      setLoading(false);
    }
  }

  function getImages(level){
    return(
      <img
      className="overlap-group-2"
      src={imgArray[level]}
    ></img>
    )
  }

  function getBigImages(level){
    return(
      <img
      className="vt-img"
      src={imgArray[level-1]}
    ></img>
    )
  }
  function getBigOverheadImages(level){
    return(
      <img
      className="vt-img"
      src={overheadImgArray[level-1]}
    ></img>
    )
  }


  async function getLayer(max, type, palletid, quadNo, levelNo) {
    let layerDone = await Utils.returnPlaceBoxesByLayer(
      type,
      palletid,
      quadNo,
      levelNo
    ).then((result) => {
      console.log("max:"+ levels+", current level:"+levelNo)
      if(levelNo===max)
        setLoading(false);

      if (result.length != 0) {
        allLayers[levelNo]={ type, palletid, quadNo, levelNo, result };
        console.log("saving "+levelNo+" with results of"+ result.length);
      }
    });
    console.log("done with layer");

    return layerDone;
  }

  async function getLevels(type, palletid, quadNo) {
    let maxLevel = await Utils.returnPlaceBoxesMaxLayer(
      type,
      palletid,
      quadNo,
    );
    console.log("max level:"+ maxLevel)
    return maxLevel;
    //return Math.ceil((maxLevel-1)/4);
  }

  function renderLevels(type, palletid, quadNo, levelNo) {
    console.log("render level : " + levelNo);
    let imgArrayLevel=levelNo*2;

    if (levelNo > levels) {
      return <div></div>;
    } else {
      return (
        <div className="top">
          <div className="frame-11">
            <div className="frame-11-wrapper">
              <div className="image-ref">
                <div className="div-2-wrapper">
                  <div className="text-wrapper-10-1">Image Reference</div>
                </div>
              </div>
            </div>
          </div>
          <div className="vq-st">
            {getBigImages(imgArrayLevel)}{getBigOverheadImages(imgArrayLevel)}
            <Chip className="chip" label={"Step " + levelNo} />
            {returnIsuDoor(type)}
          </div>
          <div className="blank"></div>
          <div className="tables">
            <div className="frame-11">
              <div className="frame-15">
                <div className="frame-16">
                  <div className="frame-17">
                    <div className="text-wrapper-10">NIIN</div>
                  </div>
                  <div className="frame-18">
                    <div className="text-wrapper-10">Order</div>
                  </div>
                  <div className="frame-14">
                    <div className="text-wrapper-10">Directions</div>
                  </div>
                </div>
              </div>
              <div className="frame-15">
                <div className="frame-16">
                  <div className="frame-17">
                    <div className="text-wrapper-10">NIIN</div>
                  </div>
                  <div className="frame-18">
                    <div className="text-wrapper-10">Order</div>
                  </div>
                  <div className="frame-14">
                    <div className="text-wrapper-10">Directions</div>
                  </div>
                </div>
              </div>
              <div className="frame-15">
                <div className="frame-16">
                  <div className="frame-17">
                    <div className="text-wrapper-10">NIIN</div>
                  </div>
                  <div className="frame-18">
                    <div className="text-wrapper-10">Order</div>
                  </div>
                  <div className="frame-14">
                    <div className="text-wrapper-10">Directions</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="div-3">
              <div className="div-4">
                {basicTable(type, palletid, quadNo, levelNo, 1)}
              </div>
              <div className="div-4">
                {basicTable(type, palletid, quadNo, levelNo, 2)}
              </div>
              <div className="div-4">
                {basicTable(type, palletid, quadNo, levelNo, 3)}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  function returnIsuDoor(storagetype){
    console.log("is door there " + storagetype)
    if(storagetype==="ISU-90")
      return(<div className="text-wrapper-3">Door</div>)
    return;
  }

  function basicTable(type, palletid, quadNo, levelNo, half) {
    console.log("hit basicTable level is:" + levelNo);
    let rows = [];
    /*if (allLayers[levelNo]){
      console.log("AllLayers "+levelNo+" items:" + JSON.stringify(allLayers[levelNo]));
      let element= allLayers[levelNo];
      rows=element.result;
    }*/
    rows = allLayers[levelNo]?.result?.slice().sort((a, b) => a.position_no - b.position_no) || [];

    var half_length = Math.ceil(rows.length / 3);
    //console.log("half "+ half_length)
    let newRows;
    if (half === 1) {
      console.log("1st half ");
      newRows = rows.slice(0, half_length);
    } else if (half === 2){
      console.log("2nd half ");
      newRows = rows.slice(half_length, half_length*2);
    }
    else
    {
      console.log("3rd part ");
      newRows = rows.slice(half_length*2);
    }

    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 189 }} aria-label="simple table">
          <TableBody>
            {newRows.map((row) => (
              <StyledTableRow
                key={row.niin}
                style={{ height: 10 }}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <StyledTableCell width="33%" component="th" align="center" scope="row">
                  {String(row.niin).slice(-4)}
                </StyledTableCell>
                <StyledTableCell width="33%" align="center">
                  #{row.position_no}
                </StyledTableCell>
                <StyledTableCell width="33%" align="center">
                  {roationImage(row.width, row.length)}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  function roationImage(width, length) {
    const numericWidth = parseFloat(width);
    const numericLength = parseFloat(length);
    if (numericWidth>=numericLength){
      return (
        <img
          src={longhorizontal}
          className="checkmark"
          alt="check"
          width="20px"
          height="20px"
        />
      );
    } else {
      return (
        <img
          src={longvertical}
          className="checkmark"
          alt="check"
          width="20"
          height="20"
        />
      );
    }
  }

  const [tick, setTick] = useState(0);

  useEffect(() => {
    // Set up the timer to rerender after 60 seconds
    const timer = setTimeout(() => {
      setTick(prevTick => prevTick + 1); // Increment state to force rerender
    }, 5000); // 60000 milliseconds = 60 seconds
    setLoading(false)
    return () => clearTimeout(timer);
  }, [tick]); // Dependency array to re-run useEffect when tick changes

  function additionalPages(isuNo, type, quadNo, pageNumber) {
    let currentLevel = pageNumber+1;
    return (
      <div className="printout">
        <div className="frame-5">
          <div className="frame-6">
            {renderLevels(type, 1, quadNo, currentLevel)}
          </div>
        </div>

        <div className="frame-footer">
            <img
              className="divider-horizontal-instance"
              src={require("../assets/Divider.png")}
            />
            <div className="frame-wrapper">
              <div className="frame-7">
                <div className="frame-8">
                  <div className="div-wrapper">
                    <div className="text-wrapper-7">#N</div>
                  </div>
                  <p className="this-symbol">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">positioning order</span>
                  </p>
                </div>
                <div className="frame-10">
                  <img
                    className="component"
                    src={require("../assets/longhorizontal.svg")}
                  />
                  <p className="this-symbol-2">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">
                      longest side direction
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }

  function isu90Pages(isuNo, quadNo) {
    let addonPages= levels;
    //let addonPages = Math.ceil((levels - 1) / 2);
    //console.log("added levels: "+ levels);
    //console.log("added pages:"+ addonPages);


    console.log("about to render:" + isuNo + "," + quadNo);
    return (
      <div>
        <div className="printout">
          <Button className="backbutton" href="#/finalPackingPage" onClick={handleClearStates}>Back</Button>
          <div className="frame">
            <div className="frame-2">
              <p className="headline-copy">
                <span className="text-wrapper">Packing Instructions: </span>
                <span className="span">optimization and agility </span>
              </p>
              <img
                className="logo-vertical-instance"
                src={require("../assets/14bis-logo-vertical.png")}
              />
            </div>
            <p className="element-find-the-boxes-for">
              1- Find the boxes for each floor by identifying last 4 digits of NIIN.
              <br />
              <br />
              2- For each box, look at the arrow to determine which wall the
              longest side of the box should lean against. <br />
              <br />
              3- Put each box into the correct position on each layer.
            </p>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <div className="frame-3">
            <div className="div-2">
              <div className="text-wrapper-2">Quadrants</div>
              <div className="overlap-group-wrapper">
                {switchImages()}
              </div>
            </div>
            <div className="div-2">
              <div className="text-wrapper-2">Final Packing Views</div>
              <div className="frame-4">
                {getImages(imgArray.length-1)}
              </div>
              <div className="text-wrapper-4">Door</div>
            </div>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <p className="ISU-quadrant">
            ISU {isuNo} - Quadrant 0{quadNo}&nbsp;&nbsp;| Step by Step
          </p>
          <div className="frame-5">
            <div className="frame-6">
            {getBigImages(imgArray.length)}{getBigOverheadImages(imgArray.length)}
            </div>
          </div>
          <div className="frame-footer">
            <img
              className="divider-horizontal-instance"
              src={require("../assets/Divider.png")}
            />
            <div className="frame-wrapper">
              <div className="frame-7">
                <div className="frame-8">
                  <div className="div-wrapper">
                    <div className="text-wrapper-7">#N</div>
                  </div>
                  <p className="this-symbol">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">positioning order</span>
                  </p>
                </div>
                <div className="frame-10">
                  <img
                    className="component"
                    src={require("../assets/longhorizontal.svg")}
                  />
                  <p className="this-symbol-2">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">
                      longest side direction
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {Array.from({ length: addonPages }, (_, index) => (
          <React.Fragment key={index}>
            {additionalPages(isuNo, "ISU-90", quadNo, index)}
          </React.Fragment>
        ))}
      </div>
    );
  }

  function flatPalletPages(containerID) {
    let addonPages = levels
    return (
      <div>
        <div className="printout">
          <Button className="backbutton" href="#/finalPackingPage" onClick={handleClearStates}>
            Back
          </Button>
          <div className="frame">
            <div className="frame-2">
              <p className="headline-copy">
                <span className="text-wrapper">Packing Instructions: </span>
                <span className="span">optimization and agility </span>
              </p>
              <img
                className="logo-vertical-instance"
                src={require("../assets/14bis-logo-vertical.png")}
              />
            </div>
            <p className="element-find-the-boxes-for">
              1- Find the boxes for each floor by identifying last 4 digits of NIIN.
              <br />
              <br />
              2- For each box, look at the arrow to determine which wall the
              longest side of the box should lean against. <br />
              <br />
              3- Put each box into the correct position on each layer.
            </p>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <div className="frame-3">
            <div className="div-2">
              <div className="text-wrapper-2">Pallet</div>
              <div className="overlap-group-wrapper">
                <img
                  className="overlap-group-2"
                  src={require("../assets/463LSize.png")}
                ></img>
              </div>
            </div>
            <div className="div-2">
              <div className="text-wrapper-2">Final Packing Views</div>
              <div className="frame-4">{getImages(imgArray.length - 1)}</div>
            </div>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <p className="ISU-quadrant">
            463L | Pallet 0{containerID}&nbsp;&nbsp;| Step by Step
          </p>
          <div className="frame-5">
            <div className="frame-6">
            {getBigImages(imgArray.length)}{getBigOverheadImages(imgArray.length)}
            </div>
          </div>
          <div className="frame-footer">
            <img
              className="divider-horizontal-instance"
              src={require("../assets/Divider.png")}
            />
            <div className="frame-wrapper">
              <div className="frame-7">
                <div className="frame-8">
                  <div className="div-wrapper">
                    <div className="text-wrapper-7">#N</div>
                  </div>
                  <p className="this-symbol">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">positioning order</span>
                  </p>
                </div>
                <div className="frame-10">
                  <img
                    className="component"
                    src={require("../assets/longhorizontal.svg")}
                  />
                  <p className="this-symbol-2">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">
                      longest side direction
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {Array.from({ length: addonPages }, (_, index) => (
            <React.Fragment key={index}>
              {additionalPages(containerID, "463L", 1, index)}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  function cPalletPages(containerID) {
    let addonPages = levels;
    return (
      <div>
        <div className="printout">
          <Button className="backbutton" href="#/finalPackingPage"  onClick={handleClearStates}>
            Back
          </Button>
          <div className="frame">
            <div className="frame-2">
              <p className="headline-copy">
                <span className="text-wrapper">Packing Instructions: </span>
                <span className="span">optimization and agility </span>
              </p>
              <img
                className="logo-vertical-instance"
                src={require("../assets/14bis-logo-vertical.png")}
              />
            </div>
            <p className="element-find-the-boxes-for">
              1- Find the boxes for each floor by identifying last 4 digits of NIIN.
              <br />
              <br />
              2- For each box, look at the arrow to determine which wall the
              longest side of the box should lean against. <br />
              <br />
              3- Put each box into the correct position on each layer.
            </p>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <div className="frame-3">
            <div className="div-2">
              <div className="text-wrapper-2">Pallet</div>
              <div className="overlap-group-wrapper">
                <img
                  className="overlap-group-2"
                  src={require("../assets/463LSize.png")}
                ></img>
              </div>
            </div>
            <div className="div-2">
              <div className="text-wrapper-2">Final Packing Views</div>
              <div className="frame-4">{getImages(imgArray.length - 1)}</div>
            </div>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <p className="ISU-quadrant">
            C463L | Pallet 0{containerID}&nbsp;&nbsp;| Step by Step
          </p>
          <div className="frame-5">
            <div className="frame-6">
            {getBigImages(imgArray.length)}{getBigOverheadImages(imgArray.length)}
            </div>
          </div>
          <div className="frame-footer">
            <img
              className="divider-horizontal-instance"
              src={require("../assets/Divider.png")}
            />
            <div className="frame-wrapper">
              <div className="frame-7">
                <div className="frame-8">
                  <div className="div-wrapper">
                    <div className="text-wrapper-7">#N</div>
                  </div>
                  <p className="this-symbol">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">positioning order</span>
                  </p>
                </div>
                <div className="frame-10">
                  <img
                    className="component"
                    src={require("../assets/longhorizontal.svg")}
                  />
                  <p className="this-symbol-2">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">
                      longest side direction
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {Array.from({ length: addonPages }, (_, index) => (
            <React.Fragment key={index}>
              {additionalPages(containerID, "C463L", 1, index)}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  function NFEVPalletPages(containerID) {
    let addonPages = levels;
    return (
      <div>
        <div className="printout">
          <Button className="backbutton" href="#/finalPackingPage" onClick={handleClearStates}>
            Back
          </Button>
          <div className="frame">
            <div className="frame-2">
              <p className="headline-copy">
                <span className="text-wrapper">Packing Instructions: </span>
                <span className="span">optimization and agility </span>
              </p>
              <img
                className="logo-vertical-instance"
                src={require("../assets/14bis-logo-vertical.png")}
              />
            </div>
            <p className="element-find-the-boxes-for">
              1- Find the boxes for each floor by identifying last 4 digits of NIIN.
              <br />
              <br />
              2- For each box, look at the arrow to determine which wall the
              longest side of the box should lean against. <br />
              <br />
              3- Put each box into the correct position on each layer.
            </p>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <div className="frame-3">
            <div className="div-2">
              <div className="text-wrapper-2">Pallet</div>
              <div className="overlap-group-wrapper">
                <img
                  className="overlap-group-2"
                  src={require("../assets/463L.png")}
                ></img>
              </div>
            </div>
            <div className="div-2">
              <div className="text-wrapper-2">Final Packing Views</div>
              <div className="frame-4">{getImages(imgArray.length - 1)}</div>
            </div>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <p className="ISU-quadrant">
            NFEV | Pallet 0{containerID}&nbsp;&nbsp;| Step by Step
          </p>
          <div className="frame-5">
            <div className="frame-6">
            {getBigImages(imgArray.length)}{getBigOverheadImages(imgArray.length)}
            </div>
          </div>
          <div className="frame-footer">
            <img
              className="divider-horizontal-instance"
              src={require("../assets/Divider.png")}
            />
            <div className="frame-wrapper">
              <div className="frame-7">
                <div className="frame-8">
                  <div className="div-wrapper">
                    <div className="text-wrapper-7">#N</div>
                  </div>
                  <p className="this-symbol">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">positioning order</span>
                  </p>
                </div>
                <div className="frame-10">
                  <img
                    className="component"
                    src={require("../assets/longhorizontal.svg")}
                  />
                  <p className="this-symbol-2">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">
                      longest side direction
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {Array.from({ length: addonPages }, (_, index) => (
            <React.Fragment key={index}>
              {additionalPages(containerID, "NFEV", 1, index)}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  function Pallet80x120Pages(containerID) {
    let addonPages = levels;
    return (
      <div>
        <div className="printout">
          <Button className="backbutton" href="#/finalPackingPage" onClick={handleClearStates}>
            Back
          </Button>
          <div className="frame">
            <div className="frame-2">
              <p className="headline-copy">
                <span className="text-wrapper">Packing Instructions: </span>
                <span className="span">optimization and agility </span>
              </p>
              <img
                className="logo-vertical-instance"
                src={require("../assets/14bis-logo-vertical.png")}
              />
            </div>
            <p className="element-find-the-boxes-for">
              1- Find the boxes for each floor by identifying last 4 digits of NIIN.
              <br />
              <br />
              2- For each box, look at the arrow to determine which wall the
              longest side of the box should lean against. <br />
              <br />
              3- Put each box into the correct position on each layer.
            </p>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <div className="frame-3">
            <div className="div-2">
              <div className="text-wrapper-2">Pallet</div>
              <div className="overlap-group-wrapper">
                <img
                  className="overlap-group-2"
                  src={require("../assets/463L.png")}
                ></img>
              </div>
            </div>
            <div className="div-2">
              <div className="text-wrapper-2">Final Packing Views</div>
              <div className="frame-4">{getImages(imgArray.length - 1)}</div>
            </div>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <p className="ISU-quadrant">
            80x120 | Pallet 0{containerID}&nbsp;&nbsp;| Step by Step
          </p>
          <div className="frame-5">
            <div className="frame-6">
            {getBigImages(imgArray.length)}{getBigOverheadImages(imgArray.length)}
            </div>
          </div>
          <div className="frame-footer">
            <img
              className="divider-horizontal-instance"
              src={require("../assets/Divider.png")}
            />
            <div className="frame-wrapper">
              <div className="frame-7">
                <div className="frame-8">
                  <div className="div-wrapper">
                    <div className="text-wrapper-7">#N</div>
                  </div>
                  <p className="this-symbol">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">positioning order</span>
                  </p>
                </div>
                <div className="frame-10">
                  <img
                    className="component"
                    src={require("../assets/longhorizontal.svg")}
                  />
                  <p className="this-symbol-2">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">
                      longest side direction
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {Array.from({ length: addonPages }, (_, index) => (
            <React.Fragment key={index}>
              {additionalPages(containerID, "80x120", 1, index)}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  function Pallet100x120Pages(containerID) {
    let addonPages = levels;
    return (
      <div>
        <div className="printout">
          <Button className="backbutton" href="#/finalPackingPage" onClick={handleClearStates}>
            Back
          </Button>
          <div className="frame">
            <div className="frame-2">
              <p className="headline-copy">
                <span className="text-wrapper">Packing Instructions: </span>
                <span className="span">optimization and agility </span>
              </p>
              <img
                className="logo-vertical-instance"
                src={require("../assets/14bis-logo-vertical.png")}
              />
            </div>
            <p className="element-find-the-boxes-for">
              1- Find the boxes for each floor by identifying last 4 digits of NIIN.
              <br />
              <br />
              2- For each box, look at the arrow to determine which wall the
              longest side of the box should lean against. <br />
              <br />
              3- Put each box into the correct position on each layer.
            </p>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <div className="frame-3">
            <div className="div-2">
              <div className="text-wrapper-2">Pallet</div>
              <div className="overlap-group-wrapper">
                <img
                  className="overlap-group-2"
                  src={require("../assets/463L.png")}
                ></img>
              </div>
            </div>
            <div className="div-2">
              <div className="text-wrapper-2">Final Packing Views</div>
              <div className="frame-4">{getImages(imgArray.length - 1)}</div>
            </div>
          </div>
          <img
            className="divider-horizontal-instance"
            src={require("../assets/Divider.png")}
          />
          <p className="ISU-quadrant">
            100x120 | Pallet 0{containerID}&nbsp;&nbsp;| Step by Step
          </p>
          <div className="frame-5">
            <div className="frame-6">
            {getBigImages(imgArray.length)}{getBigOverheadImages(imgArray.length)}
            </div>
          </div>
          <div className="frame-footer">
            <img
              className="divider-horizontal-instance"
              src={require("../assets/Divider.png")}
            />
            <div className="frame-wrapper">
              <div className="frame-7">
                <div className="frame-8">
                  <div className="div-wrapper">
                    <div className="text-wrapper-7">#N</div>
                  </div>
                  <p className="this-symbol">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">positioning order</span>
                  </p>
                </div>
                <div className="frame-10">
                  <img
                    className="component"
                    src={require("../assets/longhorizontal.svg")}
                  />
                  <p className="this-symbol-2">
                    <span className="text-wrapper-8">
                      This symbol represents the{" "}
                    </span>
                    <span className="text-wrapper-9">
                      longest side direction
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {Array.from({ length: addonPages }, (_, index) => (
            <React.Fragment key={index}>
              {additionalPages(containerID, "100x120", 1, index)}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  useLayoutEffect(() => {
    addImages();
    waitForSetContainers();
  }, [isLoading]);

  if (isLoading) {
    return <div className="App">Loading...</div>;
  } else if (storagetype === "ISU-90") {
    return (<div>
            {isu90Pages(containerID, quadid)}
      </div>)
  } else if (storagetype === "463L") {
    console.log("print 463L")
    return (<div>
      {flatPalletPages(containerID)}
    </div>);
  } else if (storagetype === "C463L") {
    return (<div>
      {cPalletPages(containerID)}
    </div>);
  } else if (storagetype === "NFEV") {
    return (<div>
      {NFEVPalletPages(containerID)}
    </div>);
  } else if (storagetype === "80x120") {
    return (<div>
      {Pallet80x120Pages(containerID)}
    </div>);
  } else if (storagetype === "100x120") {
    return (<div>
      {Pallet100x120Pages(containerID)}
    </div>);
  }
  return <div><Button href="#/finalPackingPage" onClick={handleClearStates}>Back</Button>
  </div>;

};

export default Printout;
